import React, { useState } from 'react';
import produce from 'immer';
import * as StyledFilterMenu from './filterMenuStyles';
import { indexArray } from '../../../helpers/arrayHelpers/arrayHelpers';

const FilterMenu = ({
	values,
	selectedValues,
	onSave
}) => {
	const indexedSelectedValues = indexArray(selectedValues, 'id');
	const indexedValues = indexArray(values, 'id');
	const [selected, setSelected] = useState(indexedSelectedValues);

	const onFilterClick = (id) => {
		const newFilters = produce(selected, (draft) => {
			if(draft[id]) delete draft[id];
			else draft[id] = indexedValues[id];
		});

		setSelected(newFilters);
		onSave(Object.values(newFilters));
	};

	return (
		<>
			{
				values.map(location => (
					<StyledFilterMenu.CheckWrapper
						checked={!!selected[location.id]}
						onClick={onFilterClick.bind(null, location.id)}
						key={location.id}>
						<StyledFilterMenu.Line>
							<StyledFilterMenu.Check />
							<StyledFilterMenu.Text>
								{location.label}
							</StyledFilterMenu.Text>
						</StyledFilterMenu.Line>
					</StyledFilterMenu.CheckWrapper>
				))
			}
		</>
	);
};

export default FilterMenu;
